module.exports = __webpack_public_path__ + "img/partner_icon.492ca34a.svg";